import React, { useState } from 'react';
import Modal from 'react-modal';
import './Modal.css'

const JoinWaitlistModal = ({ isOpen, onRequestClose }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    panCard: '',
    aadharCard: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted with data:', formData);
    // Reset form data
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      panCard: '',
      aadharCard: '',
    });
    // Close the modal
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Join Waitlist Modal"
      className="join-waitlist-modal"
    >
      <h2>Join Waitlist</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <input
            type="text"
            name="firstName"
            placeholder='FirstName*'
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />
        </label>
        <label>
          <input
            type="text"
            name="lastName"
            placeholder='Last Name*'
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />
        </label>
        <label>
          <input
            type="email"
            name="email"
            placeholder='Email*'
            value={formData.email}
            onChange={handleInputChange}
            required
          />
        </label>
        <label>
          <input
            type="text"
            name="panCard"
            placeholder='Pan Card number*'
            value={formData.panCard}
            onChange={handleInputChange}
            required
          />
        </label>
        <label>
          <input
            type="text"
            name="aadharCard"
            placeholder='12 digit Aadhar Number*'
            value={formData.aadharCard}
            onChange={handleInputChange}
            required
          />
        </label>
        <button type="submit">Submit</button>
      </form>
    </Modal>
  );
};

export default JoinWaitlistModal;
